(function () {

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getVariant() {
    const idInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (!idInput || !window.productVariants) return null;

    return window.productVariants.find(
      v => String(v.id) === String(idInput.value)
    );
  }

  function updateUI() {
    const variant = getVariant();
    if (!variant) return;

    // PRICE (source of truth)
    const priceEl = document.getElementById('product-price');
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    // SQUARE
    const square = document.getElementById('square-placement');
    if (square) {
      square.setAttribute('data-amount', (variant.price / 100).toFixed(2));
      square.setAttribute('data-item-skus', variant.sku || '');
    }
  }

  function init() {
    updateUI();

    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const observer = new MutationObserver(() => {
      setTimeout(updateUI, 0);
    });

    observer.observe(form, {
      subtree: true,
      childList: true,
      attributes: true
    });
  }

  document.addEventListener('DOMContentLoaded', init);

})();